import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import styles from './styles.module.scss';
import React from 'react'
import PhoneIcon from '/public/site-assets/svg/phone.svg';
import Mail from '/public/site-assets/svg/mail.svg';
import Share from '/public/site-assets/svg/share.svg';
import LinkedIn from '/public/site-assets/svg/linkedin.svg';
import Link from "next/link"

export default function ConsultantDetails({
    consultant,
    customClass = ""
}) {
    return (
        <section className={`${styles.root} ${customClass}`}>
            <Container>
                <Row>
                    <Col md={4} className="pe-md-5 mb-4 mb-md-0">
                        <SourceFlowImage
                            src={consultant?.image ? consultant.image : "/site-assets/images/image-placeholder.webp"}
                            size="800x800"
                            alt={consultant.name}
                            className="card-img rounded-3 shadow"
                            width="100%"
                            height="auto"
                        />
                    </Col>
                    <Col md={8} className="ps-md-5">
                        <Nav className="d-block contact-informations rounded-3 border mb-5">
                            {consultant.email ?
                                <NavItem className="position-relative">
                                    <Mail />
                                    <Link href={`mailto:${consultant?.email}`}>
                                        <a className="text-decoration-none">
                                            {consultant.email}
                                        </a>
                                    </Link>
                                </NavItem> : null}
                            {consultant.telephone ?
                                <NavItem className="position-relative">
                                    <PhoneIcon />
                                    <Link href={`tel:${consultant?.telephone}`}>
                                        <a className="text-decoration-none">
                                            {consultant.telephone}
                                        </a>
                                    </Link>
                                </NavItem> : null}
                            {consultant.linkedin ?
                                <NavItem className="position-relative">
                                    <Share />
                                    <Link href={`${consultant?.linkedin}`}>
                                        <a className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                            <LinkedIn />
                                        </a>
                                    </Link>
                                </NavItem> : null}
                        </Nav>
                        {consultant?.content ?
                            <div className="description" dangerouslySetInnerHTML={{ __html: consultant?.content }} />
                            : ""}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}